import { call, put } from 'redux-saga/effects';
import { Types } from './actions';
import ProfileRepository from '../../../repositories/ProfileRepository';
import ProfileDataRepository from '../../../../data/repositories/ProfileDataRepository';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.UPDATE_DATA_PROFILE_REQUEST });

    const profileRepository: ProfileRepository = new ProfileDataRepository();

    const profileResponse = yield call(
      profileRepository.updateDataProfile,
      action.newValue,
      action.oldValue,
      action.types,
      action.validationCode
    );

    if (!profileResponse) {
      throw new Error('Error');
    }

    yield put({
      type: Types.UPDATE_DATA_PROFILE_SUCCESS,
      data: profileResponse
    });

    yield put({ type: 'GET_EMAIL_AND_PHONE' });
  } catch (error) {
    yield put({
      type: Types.UPDATE_DATA_PROFILE_FAILURE,
      error: 'Error'
    });
  }
}
